import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, BookOpen } from 'lucide-react';
import { getAllPostsAsync } from '../../services/blogService';
import './BlogList.css';

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    getAllPostsAsync().then((data) => {
      if (isMounted) {
        setPosts(data);
        setLoading(false);
      }
    });
    return () => { isMounted = false; };
  }, []);

  return (
    <div className="blog-page">
      {/* ─── Hero Section ─── */}
      <section className="blog-hero">
        <div className="blog-hero-container">
          <div className="blog-hero-badge">
            <BookOpen size={16} />
            <span>Blog</span>
          </div>
          <h1 className="blog-hero-title">
            Solar &amp; Battery Insights <br className="hero-br" />
            <span className="text-highlight">For Melbourne Homes</span>
          </h1>
        </div>
      </section>

      {/* ─── Articles Grid Section ─── */}
      <section className="blog-grid-section">
        <div className="blog-container">
          {loading ? (
            <div className="blog-loading-state">
              <p>Loading articles...</p>
            </div>
          ) : (
            <div className="blog-grid">
              {posts.map((post) => (
                <article key={post.slug} className="blog-card">
                  <Link to={`/${post.slug}`} className="blog-card-img-link">
                    <div className="blog-card-img-wrapper">
                      <img src={post.featuredImage} alt={post.imageAlt || post.title} loading="lazy" />
                    </div>
                  </Link>

                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <span className="meta-item">
                        <Calendar size={14} />
                        {new Date(post.date).toLocaleDateString('en-AU', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </span>
                    </div>

                    <h2 className="blog-card-title">
                      <Link to={`/${post.slug}`}>{post.title}</Link>
                    </h2>

                    <p className="blog-card-excerpt">{post.excerpt}</p>

                    <div className="blog-card-footer">
                      <span className="blog-author">{post.author}</span>
                      <Link to={`/${post.slug}`} className="blog-read-btn">
                        <span>Read Article</span>
                        <ArrowRight size={16} />
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
